import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getLabels } from '../labels';
const IS_DEV = false;
export default function ErrorPage({ source, message, details }) {
    const labels = getLabels();
    return (_jsxs("div", { className: "p-20", "data-testid": "errorPage", children: [_jsx("h1", { className: "mb-10 text-2xl", children: labels.unexpected[source] }), _jsx("p", { children: message }), IS_DEV ? _jsx("pre", { style: { marginTop: 16, whiteSpace: 'pre-wrap' }, children: details }) : null] }));
}
